/* eslint-disable */
import { L10n, createElement, isNullOrUndefined } from '@syncfusion/ej2-base';
import { Button } from '@syncfusion/ej2-buttons';
import { ListView } from '@syncfusion/ej2-lists';
import { TextElementBox, ErrorTextElementBox } from '../viewer/page';
import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';
/**
 * Spell check dialog
 */
export class SpellCheckDialog {
    /**
     * @param {DocumentHelper} documentHelper - Specifies the document helper.
     * @private
     */
    constructor(documentHelper) {
        this.ignoreClickHandler = this.onIgnoreClick.bind(this);
        this.ignoreAllClickHandler = this.onIgnoreAllClick.bind(this);
        this.addToDictClickHandler = this.onAddToDictClick.bind(this);
        this.selectHandlerClickHandler = this.onSelectHandlerClick.bind(this);
        this.changeButtonClickHandler = this.onChangeButtonClick.bind(this);
        this.onChangeAllButtonClickHandler = this.onChangeAllButtonClick.bind(this);
        /**
         * @param {SelectEventArgs} args - Specifies the event args.
         * @returns {void}
         */
        this.selectHandler = (args) => {
            this.selectedText = args.text;
        };
        /**
         * @private
         * @returns {void}
         */
        this.onCancelButtonClick = () => {
            this.documentHelper.clearSelectionHighlight();
            this.documentHelper.hideDialog();
        };
        /**
         * @private
         * @returns {void}
         */
        this.onIgnoreClicked = () => {
            if (!isNullOrUndefined(this.elementBox)) {
                showSpinner(this.documentHelper.dialog.element);
                this.isSpellChecking = true;
                this.parent.spellCheckerModule.manageReplace('Ignore Once', this.elementBox);
                this.removeErrors();
                this.parent.spellCheckerModule.checkForNextError();
                this.documentHelper.triggerSpellCheck = true;
                if (!isNullOrUndefined(this.documentHelper.owner.editorModule)) {
                    this.documentHelper.owner.editorModule.reLayout(this.documentHelper.selection);
                }
                this.documentHelper.triggerSpellCheck = false;
                // this.documentHelper.hideDialog();
                hideSpinner(this.documentHelper.dialog.element);
            }
        };
        /**
         * @private
         * @returns {void}
         */
        this.onIgnoreAllClicked = () => {
            if (!isNullOrUndefined(this.elementBox)) {
                showSpinner(this.documentHelper.dialog.element);
                const text = this.elementBox.text;
                this.isSpellChecking = true;
                this.parent.spellCheckerModule.handleIgnoreAllItems({ element: this.elementBox, text: text });
                this.parent.spellCheckerModule.checkForNextError();
                this.documentHelper.triggerSpellCheck = true;
                if (!isNullOrUndefined(this.documentHelper.owner.editorModule)) {
                    this.documentHelper.owner.editorModule.reLayout(this.documentHelper.selection);
                }
                this.documentHelper.triggerSpellCheck = false;
                if (this.parent.spellCheckerModule.errorWordCollection.length === 0) {
                    this.documentHelper.hideDialog();
                }
                // this.documentHelper.hideDialog();
                hideSpinner(this.documentHelper.dialog.element);
            }
        };
        /**
         * @private
         * @returns {void}
         */
        this.addToDictClicked = () => {
            if (!isNullOrUndefined(this.elementBox)) {
                showSpinner(this.documentHelper.dialog.element);
                this.parent.spellCheckerModule.handleAddToDictionary({ element: this.elementBox, text: this.elementBox.text });
                if (this.parent.spellCheckerModule.errorWordCollection.containsKey(this.errorText)) {
                    this.parent.spellCheckerModule.errorWordCollection.remove(this.errorText);
                }
                this.parent.spellCheckerModule.checkForNextError();
                this.documentHelper.hideDialog();
            }
        };
        /**
         * @private
         * @returns {void}
         */
        this.changeButtonClicked = () => {
            if (!isNullOrUndefined(this.selectedText)) {
                this.isSpellChecking = true;
                showSpinner(this.documentHelper.dialog.element);
                this.parent.spellCheckerModule.manageReplace(this.selectedText, this.elementBox);
                this.removeErrors();
                this.parent.spellCheckerModule.checkForNextError();
                this.documentHelper.triggerSpellCheck = true;
                if (!isNullOrUndefined(this.documentHelper.owner.editorModule)) {
                    this.documentHelper.owner.editorModule.reLayout(this.documentHelper.selection);
                }
                this.documentHelper.triggerSpellCheck = false;
                hideSpinner(this.documentHelper.dialog.element);
                this.selectedText = undefined;
            }
        };
        /**
         * @private
         * @returns {void}
         */
        this.changeAllButtonClicked = () => {
            if (!isNullOrUndefined(this.selectedText)) {
                this.isSpellChecking = true;
                this.parent.spellCheckerModule.isChangeAll = true;
                showSpinner(this.documentHelper.dialog.element);
                const errorElements = this.parent.spellCheckerModule.errorWordCollection.get(this.errorText);
                // shallow copying the errorElements
                const elements = errorElements.slice();
                for (let i = elements.length - 1; i >= 0; i--) {
                    if (elements[i] instanceof ErrorTextElementBox && !elements[i].isChangeDetected) {
                        this.parent.spellCheckerModule.manageReplace(this.selectedText, elements[i], true);
                    }
                    else if (elements[i] instanceof TextElementBox) {
                        const matchResults = this.parent.spellCheckerModule.getMatchedResultsFromElement(elements[i]);
                        const results = matchResults.textResults;
                        const markIndex = (elements[i].isChangeDetected && elements[i].start) ?
                            elements[i].start.offset : elements[i].line.getOffset(elements[i], 0);
                        this.parent.searchModule.textSearch.updateMatchedTextLocation(matchResults.matches, results, matchResults.elementInfo, 0, elements[i], false, null, markIndex);
                        for (let j = 0; j < results.length; j++) {
                            const element = this.parent.spellCheckerModule.createErrorElementWithInfo(results.innerList[j], elements[i]);
                            this.parent.spellCheckerModule.manageReplace(this.selectedText, element, true);
                        }
                    }
                }
                if (this.parent.spellCheckerModule.errorWordCollection.containsKey(this.errorText)) {
                    this.parent.spellCheckerModule.errorWordCollection.remove(this.errorText);
                }
                this.parent.spellCheckerModule.checkForNextError();
                this.documentHelper.triggerSpellCheck = true;
                if (!isNullOrUndefined(this.documentHelper.owner.editorModule)) {
                    this.documentHelper.owner.editorModule.reLayout(this.documentHelper.selection);
                }
                this.documentHelper.triggerSpellCheck = false;
                this.documentHelper.hideDialog();
                hideSpinner(this.documentHelper.dialog.element);
                this.parent.spellCheckerModule.isChangeAll = false;
                this.selectedText = undefined;
            }
        };
        this.documentHelper = documentHelper;
        if (this.documentHelper) {
            createSpinner({ target: this.documentHelper.dialog.element, cssClass: 'e-spin-overlay' });
        }
    }
    get parent() {
        return this.documentHelper.owner;
    }
    getModuleName() {
        return 'SpellCheckDialog';
    }
    onSelectHandlerClick(args) {
        this.selectHandler(args);
    }
    onIgnoreClick() {
        this.onIgnoreClicked();
    }
    /**
     * @private
     */
    removeErrors() {
        if (!isNullOrUndefined(this.errorText) && this.parent.spellCheckerModule.errorWordCollection.containsKey(this.errorText)) {
            const textElement = this.parent.spellCheckerModule.errorWordCollection.get(this.errorText);
            if (this.parent.spellCheckerModule.handleErrorElements.indexOf(this.elementBox) === -1) {
                this.parent.spellCheckerModule.handleErrorElements.push(this.elementBox);
            }
            if (textElement && textElement.length > 0) {
                for (let i = 0; i < this.parent.spellCheckerModule.handleErrorElements.length; i++) {
                    const errorElement = this.parent.spellCheckerModule.handleErrorElements[i];
                    const index = textElement.indexOf(errorElement);
                    if (index !== -1) {
                        textElement.splice(index, 1);
                    }
                }
            }
            this.parent.spellCheckerModule.handleErrorElements = [];
            if (textElement.length === 0) {
                this.parent.spellCheckerModule.errorWordCollection.remove(this.errorText);
            }
        }
        if (this.parent.spellCheckerModule.errorWordCollection.length === 0) {
            this.documentHelper.hideDialog();
        }
    }
    onIgnoreAllClick() {
        this.onIgnoreAllClicked();
    }
    onAddToDictClick() {
        this.addToDictClicked();
    }
    onChangeButtonClick() {
        this.changeButtonClicked();
    }
    onChangeAllButtonClick() {
        this.changeAllButtonClicked();
    }
    /**
     * @private
     * @param {string} error - Specifies error element box.
     * @param {ElementBox} elementbox - Specifies the element box.
     * @returns {void}
     */
    show(error, elementbox) {
        this.target = undefined;
        this.localValue = new L10n('documenteditor', this.documentHelper.owner.defaultLocale);
        this.localValue.setLocale(this.documentHelper.owner.locale);
        if (!this.target) {
            this.parent.spellCheckerModule.triggerErrorForNonRenderPages();
            this.updateSuggestionDialog(error, elementbox);
        }
    }
    /**
     * @private
     * @param {string} error - Specifies error element box.
     * @param {ElementBox} elementbox - Specifies the element box.
     * @returns {void}
     */
    updateSuggestionDialog(error, elementBox) {
        this.elementBox = elementBox;
        let suggestions;
        if (this.isSpellChecking) {
            /* eslint-disable @typescript-eslint/no-explicit-any */
            this.parent.spellCheckerModule.callSpellChecker(this.parent.spellCheckerModule.languageID, error, false, true).then((data) => {
                /* eslint-disable @typescript-eslint/no-explicit-any */
                const jsonObject = JSON.parse(data);
                suggestions = jsonObject.Suggestions;
                if (!isNullOrUndefined(suggestions)) {
                    this.parent.spellCheckerModule.errorSuggestions.add(error, suggestions.slice());
                }
                this.isSpellChecking = false;
                this.handleRetrievedSuggestion(error, suggestions);
            });
        }
        else {
            error = this.parent.spellCheckerModule.manageSpecialCharacters(error, undefined, true);
            suggestions = this.parent.spellCheckerModule.errorSuggestions.containsKey(error) ?
                this.parent.spellCheckerModule.errorSuggestions.get(error) : [];
            this.handleRetrievedSuggestion(error, suggestions);
        }
    }
    handleRetrievedSuggestion(error, suggestions) {
        error = this.parent.spellCheckerModule.manageSpecialCharacters(error, undefined, true);
        this.initSpellCheckDialog(this.localValue, error, suggestions);
        if (this.documentHelper.selection.caret.style.display !== 'none') {
            this.documentHelper.selection.caret.style.display = 'none';
        }
        this.documentHelper.dialog.header = this.localValue.getConstant('Spelling Editor');
        this.documentHelper.dialog.height = 'auto';
        this.documentHelper.dialog.width = 'auto';
        this.documentHelper.dialog.content = this.target;
        this.documentHelper.dialog.beforeOpen = this.documentHelper.updateFocus;
        this.documentHelper.dialog.buttons = [{
                click: this.onCancelButtonClick,
                buttonModel: { content: this.localValue.getConstant('Cancel'), cssClass: 'e-control e-flat', isPrimary: true }
            }];
        this.documentHelper.dialog.dataBind();
        this.documentHelper.dialog.show();
        hideSpinner(this.documentHelper.dialog.element);
    }
    /**
     * @private
     * @param {L10n} localValue - Specifies the locale value.
     * @param {string} error - Specifies the error text.
     * @param {string[]} suggestion - Specifies the suggestion.
     * @param {boolean} isRtl - Specifies the is rtl
     * @returns {void}
     */
    initSpellCheckDialog(localValue, error, suggestion, isRtl) {
        const id = this.documentHelper.owner.containerId + '_add_SpellCheck';
        this.target = createElement('div', { id: id, className: 'e-de-insert-spellchecker' });
        this.errorText = error;
        this.textContainer = createElement('div', {
            className: 'e-de-dlg-sub-header', innerHTML: localValue.getConstant('Spelling')
        });
        this.target.appendChild(this.textContainer);
        this.spellContainer = createElement('div', { className: 'e-de-spellcheck-error-container' });
        this.listviewDiv = createElement('div', { className: 'e-de-dlg-spellcheck-listview' });
        this.spellContainer.appendChild(this.listviewDiv);
        this.spellingListView = new ListView({
            dataSource: [error],
            cssClass: 'e-dlg-spellcheck-listitem'
        });
        this.spellingListView.appendTo(this.listviewDiv);
        this.buttonDiv = createElement('div', { className: 'e-de-spellcheck-btncontainer' });
        this.spellContainer.appendChild(this.buttonDiv);
        this.ignoreButtonElement = createElement('button', { innerHTML: localValue.getConstant('Ignore') });
        this.buttonDiv.appendChild(this.ignoreButtonElement);
        this.ignoreButtonElement.setAttribute('aria-label', localValue.getConstant('Ignore'));
        this.ignorebutton = new Button({ cssClass: 'e-control e-de-ok-button e-de-spellcheck-btn' });
        this.ignorebutton.appendTo(this.ignoreButtonElement);
        this.ignoreButtonElement.addEventListener('click', this.ignoreClickHandler);
        this.ignoreAllButtonElement = createElement('button', { innerHTML: localValue.getConstant('Ignore All') });
        this.ignoreAllButtonElement.setAttribute('aria-label', localValue.getConstant('Ignore All'));
        this.buttonDiv.appendChild(this.ignoreAllButtonElement);
        this.ignoreAllbutton = new Button({ cssClass: 'e-control e-de-ok-button e-de-spellcheck-btn' });
        this.ignoreAllbutton.appendTo(this.ignoreAllButtonElement);
        this.ignoreAllButtonElement.addEventListener('click', this.ignoreAllClickHandler);
        this.addDictButtonElement = createElement('button', { innerHTML: localValue.getConstant('Add to Dictionary') });
        this.addDictButtonElement.setAttribute('aria-label', localValue.getConstant('Add to Dictionary'));
        this.buttonDiv.appendChild(this.addDictButtonElement);
        this.addDictButton = new Button({ cssClass: 'e-control e-de-ok-button e-de-spellcheck-btn' });
        this.addDictButton.appendTo(this.addDictButtonElement);
        this.addDictButtonElement.addEventListener('click', this.addToDictClickHandler);
        this.target.appendChild(this.spellContainer);
        this.suggestionDiv = createElement('div', {
            className: 'e-de-dlg-sub-header', innerHTML: localValue.getConstant('Suggestions')
        });
        this.target.appendChild(this.suggestionDiv);
        this.suggestionContainer = createElement('div', { className: 'e-de-spellcheck-suggestion-container' });
        this.target.appendChild(this.suggestionContainer);
        this.suggestListDiv = createElement('div', { className: 'e-de-dlg-spellcheck-listview' });
        this.suggestListDiv.setAttribute('aria-label', localValue.getConstant('Suggestions'));
        this.suggestionContainer.appendChild(this.suggestListDiv);
        this.suggestionListView = new ListView({
            dataSource: suggestion,
            cssClass: 'e-dlg-spellcheck-listitem'
        });
        this.suggestionListView.appendTo(this.suggestListDiv);
        this.suggestionListView.addEventListener('select', this.selectHandlerClickHandler);
        this.suggestBtnContainder = createElement('div', { className: 'e-de-spellcheck-btncontainer' });
        this.suggestionContainer.appendChild(this.suggestBtnContainder);
        this.changeButtonElement = createElement('button', { innerHTML: localValue.getConstant('Change') });
        this.changeButtonElement.setAttribute('aria-label', localValue.getConstant('Change'));
        this.suggestBtnContainder.appendChild(this.changeButtonElement);
        this.changeButton = new Button({ cssClass: 'e-control e-de-ok-button e-de-spellcheck-btn' });
        this.changeButton.appendTo(this.changeButtonElement);
        this.changeButtonElement.addEventListener('click', this.changeButtonClickHandler);
        this.changeAllButtonElement = createElement('button', { innerHTML: localValue.getConstant('Change All') });
        this.changeAllButtonElement.setAttribute('aria-label', localValue.getConstant('Change All'));
        this.suggestBtnContainder.appendChild(this.changeAllButtonElement);
        this.changeAllbutton = new Button({ cssClass: 'e-control e-de-ok-button e-de-spellcheck-btn' });
        this.changeAllbutton.appendTo(this.changeAllButtonElement);
        this.changeAllButtonElement.addEventListener('click', this.onChangeAllButtonClickHandler);
        if (isNullOrUndefined(suggestion) || suggestion.length === 0) {
            this.changeButton.disabled = true;
            this.changeAllbutton.disabled = true;
        }
    }
    /**
     * @private
     * @returns {void}
     */
    destroy() {
        if (this.target) {
            this.target.remove();
            this.target = undefined;
        }
        if (this.elementBox) {
            this.elementBox.destroy();
            this.elementBox = undefined;
        }
        this.documentHelper = undefined;
        if (this.spellingListView) {
            this.spellingListView.destroy();
            this.spellingListView = undefined;
        }
        if (this.suggestionListView) {
            this.suggestionListView.destroy();
            this.suggestionListView = undefined;
        }
        this.selectedText = undefined;
        this.removeEvents();
        this.removeElements();
    }
    removeEvents() {
        if (this.ignoreButtonElement) {
            this.ignoreButtonElement.removeEventListener('click', this.ignoreClickHandler);
        }
        if (this.ignoreAllButtonElement) {
            this.ignoreAllButtonElement.removeEventListener('click', this.ignoreAllClickHandler);
        }
        if (this.addDictButtonElement) {
            this.addDictButtonElement.removeEventListener('click', this.addToDictClickHandler);
        }
        if (this.changeButtonElement) {
            this.changeButtonElement.removeEventListener('click', this.changeButtonClickHandler);
        }
        if (this.changeAllButtonElement) {
            this.changeAllButtonElement.removeEventListener('click', this.onChangeAllButtonClickHandler);
        }
        if (this.suggestionListView) {
            this.suggestionListView.removeEventListener('select', this.selectHandlerClickHandler);
        }
    }
    removeElements() {
        if (this.textContainer) {
            this.textContainer.remove();
            this.textContainer = undefined;
        }
        if (this.spellContainer) {
            this.spellContainer.remove();
            this.spellContainer = undefined;
        }
        if (this.listviewDiv) {
            this.listviewDiv.remove();
            this.listviewDiv = undefined;
        }
        if (this.buttonDiv) {
            this.buttonDiv.remove();
            this.buttonDiv = undefined;
        }
        if (this.ignoreButtonElement) {
            this.ignoreButtonElement.remove();
            this.ignoreButtonElement = undefined;
        }
        if (this.ignorebutton) {
            this.ignorebutton.destroy();
            this.ignorebutton = undefined;
        }
        if (this.ignoreAllButtonElement) {
            this.ignoreAllButtonElement.remove();
            this.ignoreAllButtonElement = undefined;
        }
        if (this.ignoreAllbutton) {
            this.ignoreAllbutton.destroy();
            this.ignoreAllbutton = undefined;
        }
        if (this.addDictButtonElement) {
            this.addDictButtonElement.remove();
            this.addDictButtonElement = undefined;
        }
        if (this.addDictButton) {
            this.addDictButton.destroy();
            this.addDictButton = undefined;
        }
        if (this.suggestionDiv) {
            this.suggestionDiv.remove();
            this.suggestionDiv = undefined;
        }
        if (this.suggestionContainer) {
            this.suggestionContainer.remove();
            this.suggestionContainer = undefined;
        }
        if (this.suggestListDiv) {
            this.suggestListDiv.remove();
            this.suggestListDiv = undefined;
        }
        if (this.suggestBtnContainder) {
            this.suggestBtnContainder.remove();
            this.suggestBtnContainder = undefined;
        }
        if (this.changeButtonElement) {
            this.changeButtonElement.remove();
            this.changeButtonElement = undefined;
        }
        if (this.changeButton) {
            this.changeButton.destroy();
            this.changeButton = undefined;
        }
        if (this.changeAllButtonElement) {
            this.changeAllButtonElement.remove();
            this.changeAllButtonElement = undefined;
        }
        if (this.changeAllbutton) {
            this.changeAllbutton.destroy();
            this.changeAllbutton = undefined;
        }
    }
}
